<template>
    <main class="main promo">
        <div class="container">
            <ui-slider
                v-if="topBanner"
                class="promo__banner"
                :content="topBanner"
            />
            <section-header
                title="Cenówki"
                sub-title="Do każdej aktywowanej promocji możesz wygenerować cenówkę lub plakat"
                class="mb-3 mb-lg-5"
            />
            <div class="row">
                <div class="col-md-3 d-flex flex-column">
                    <the-filters
                        @applyFilters="applyFilters"
                        :filters="filters"
                        subtitle="Pokaż cenówki"
                        module-name="labelGroups"
                    />
                    <ui-slider
                        v-if="leftBanner"
                        class="promo__leftBanner"
                        :content="leftBanner"
                    />
                </div>
                <div class="col-md-9">
                    <div class="c-settings pt-2">
                        <div class="c-settings-count">
                            <span
                                v-if="
                                    pagination.totalRecords &&
                                        labelsStatus === 'idle'
                                "
                            >
                                {{
                                    pagination.totalRecords
                                        | plurals('wynik', 'wyniki', 'wyników')
                                }}
                            </span>
                        </div>
                        <div class="c-settings-filters mt-2 mt-md-0">
                            <div class="d-block ml-3">
                                <results-per-page
                                    :per-page="pagination.perPage"
                                    text="Pokazuj na stronie:"
                                    :on-change="changeResultsPerPage"
                                    :options="[5, 10, 25]"
                                ></results-per-page>
                            </div>
                            <div class="d-block ml-3">
                                <sort-component
                                    text="Sortuj po:"
                                    module-name="labelGroups"
                                    :options="
                                        $store.getters.getLabelGroupsSortOptions
                                    "
                                    @onChange="fetch"
                                ></sort-component>
                            </div>
                        </div>
                    </div>
                    <selected-filters
                        class="mb-4"
                        :filters="filters"
                        module-name="labelGroups"
                        @applyFilters="applyFilters"
                    />
                    <div class="content">
                        <page-preloader
                            v-if="!labelGroups || labelsStatus === 'loading'"
                        ></page-preloader>
                        <!-- <promotions-list
                            v-else-if="promotions.length > 0"
                            :promotions="promotions"
                            :previewType="'promo-labels'"
                        ></promotions-list> -->

                        <promo-groups
                            v-else-if="labelGroups && labelGroups.length"
                            :groups="labelGroups"
                            preview-type="promo-labels"
                            class="mb-5 mt-4"
                        ></promo-groups>

                        <div v-else>Brak wyników</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <the-pagination
                            v-if="pagination && pagination.totalPages > 1"
                            :pagination="pagination"
                            @change="onChange"
                        />
                        <results-per-page
                            text="Pokazuj na stronie:"
                            :per-page="pagination.perPage"
                            :on-change="changeResultsPerPage"
                            :options="[5, 10, 25]"
                        />
                    </div>
                    <ui-slider
                        v-if="bottomBanner"
                        class="promo__leftBanner"
                        :content="bottomBanner"
                    />
                </div>
            </div>
        </div>
        <labels-bar
            v-if="selectedLabels && selectedLabels.length > 0"
            :selected-labels="selectedLabels"
        ></labels-bar>
    </main>
</template>

<script>
import LabelsBar from '@/components/labels/LabelsBar'
import PromoGroups from '@/components/promotions/PromoGroups'

export default {
    components: {
        LabelsBar,
        PromoGroups
    },
    computed: {
        labelGroups() {
            return this.$store.getters.getLabelGroups
        },
        topBanner() {
            return this.$store.getters.getTopBanner
        },
        leftBanner() {
            return this.$store.getters.getLeftBanner
        },
        bottomBanner() {
            return this.$store.getters.getBottomBanner
        },
        pagination() {
            return this.$store.getters.getLabelGroupsPagination
        },
        promotions() {
            return this.$store.getters.getLabels
        },
        labelsStatus() {
            return this.$store.getters.getLabelGroupsStatus
        },
        selectedLabels() {
            return this.$store.getters.getSelectedLabelGroups
        },
        filters() {
            return this.$store.getters.getLabelGroupsFilters
        },
        selectAllData: {
            get() {
                return this.$store.getters.getLabelsSelectAll
            },
            set(value) {
                this.$store.dispatch('selectAllLabels', value)
            }
        },
        filterNip() {
            return this.filters['promo|subscription|merchant|nip'].value
        },
        filterSelectedMerchants() {
            return this.filters['promo|subscription|merchant_id'].value
        }
    },
    beforeCreate() {
        this.$store.dispatch('snippetsLoad', {
            code: 'snippet001',
            moduleName: 'advertisements'
        })
        this.$store.dispatch('snippetsLoad', {
            code: 'snippet002',
            moduleName: 'advertisements'
        })
        this.$store.dispatch('snippetsLoad', {
            code: 'snippet003',
            moduleName: 'advertisements'
        })
    },
    created() {
        this.$store.dispatch('resetPromotions')
        this.$store.dispatch('setDynamicPromoFilters')
        window.scrollTo(0, 0)
        this.fetch()
    },
    methods: {
        async fetch(payload) {
            const perPage = await this.$store.$storage.getItem('perPage')
            let params = {
                ...this.$route.query,
                ...payload
            }
            if (!params.per && perPage.labels) {
                params = {
                    ...params,
                    per: perPage.labels
                }
            }
            this.$store.dispatch('loadLabelGroups', {
                params,
                main: true,
                fetchPaginationOnly: true
            })
        },
        async scrollToExpandedGroup() {
            const expandedGroup = await this.$store.$storage.getItem(
                'expandedGroup'
            )
            if (expandedGroup && this.labelGroups) {
                const group = this.labelGroups.find(
                    group => group.id === expandedGroup.groupId
                )
                if (group) {
                    if (group.promosStatus === 'idle') {
                        const offset = document.querySelector(
                            '.site-header__container'
                        ).offsetHeight
                        const scrollToPromoElement = document.querySelector(
                            `[promo_id="${+expandedGroup.promoId}"][promo_group_id="${+expandedGroup.groupId}"]`
                        )
                        const scrollToGroupElement = document.querySelector(
                            `[promo_group_id="${+expandedGroup.groupId}"]`
                        )
                        this.$scrollTo(
                            scrollToPromoElement || scrollToGroupElement,
                            400,
                            {
                                offset: -offset - 20
                            }
                        )
                        this.$store.$storage.removeItem('expandedGroup')
                    }
                } else {
                    this.$store.$storage.removeItem('expandedGroup')
                }
            }
        },
        onChange(page) {
            this.$router.push({
                query: { ...this.$route.query, page: page }
            })
        },
        changeResultsPerPage(value) {
            this.$router.push({
                query: { ...this.$route.query, per: value, page: 1 }
            })
        },
        applyFilters() {
            this.$store.commit(
                'SET_SELECTED_LABELGROUPS_SELECTWHOLEGROUP',
                false
            )
            this.fetch({ fromFilters: true })
        }
    },
    watch: {
        filterSelectedMerchants() {
            for (const merchant of this.$store.getters.getAvailableMerchants) {
                for (const group of this.selectedLabels) {
                    for (const promotion of group.promos) {
                        this.$store.dispatch('selectShop', {
                            value:
                                !this.filterSelectedMerchants.length ||
                                this.filterSelectedMerchants.includes(
                                    merchant.id
                                ),
                            promoId: promotion.id,
                            groupId: promotion.groupId,
                            shopId: merchant.id,
                            promotion: promotion,
                            previewType: 'labels',
                            equalPrices:
                                promotion.subscriptionsEqualPrices
                                    .equalPrices || promotion.equalLocalCodes,
                            groupIdx: this.priceGroupIdx || 0,
                            fromPromoDetails: this.$store.getters.modalState
                                ?.args?.singleSubscription
                        })
                    }
                }
            }
        },
        filterNip: {
            handler: function(newVal, oldVal) {
                if (!newVal.length) return
                const filterMerchants = this.filters[
                    'promo|subscription|merchant_id'
                ].value
                const merchants = this.$store.getters.getMerchants
                const selectedMerchants = merchants.filter(merchant => {
                    return (
                        filterMerchants.includes(merchant.id) &&
                        newVal.includes(merchant.nip)
                    )
                })
                const merchantsToSelect = selectedMerchants
                    .filter(merchant => newVal.includes(merchant.nip))
                    .map(merchant => merchant.id)

                this.$store.dispatch('setFilter', {
                    filter: 'promo|subscription|merchant_id',
                    value: merchantsToSelect,
                    moduleName: 'labelGroups'
                })
            },
            deep: true
        },
        labelGroups: {
            handler: function() {
                const expandedGroup = this.$store.$storage.getItem(
                    'expandedGroup'
                )
                if (expandedGroup) {
                    setTimeout(() => {
                        this.scrollToExpandedGroup()
                    }, 0)
                }
            },
            deep: true
        }
    }
}
</script>
